<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .upload-info {
    min-width: 0;
    flex: 1;
  }

  .upload-name {
    @include mixins.body3;
    color: colors.get(black_90);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .upload-subtitle {
    @include mixins.body3;
    color: colors.get(textDisabledGrey);
    white-space: nowrap;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 8px;

    .upload-candidate-name {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .subtitle-divider {
    width: 1px;
    height: 21px;
    background-color: colors.get(interfaceSwGrey_10);
  }
</style>

<script>
  import { PROCESSED_STATUSES } from "../../assets";

  let { upload } = $props();

  const STATUS_TO_TEXT = {
    done: "Creating contact...",
    processing: "Creating contact...",
    error: "Failed to create contact",
  };

  const formatDate = (date) => {
    const options = { day: "numeric", month: "short" };
    return new Date(date * 1000).toLocaleDateString("en-GB", options);
  };
</script>

<div class="upload-info">
  <div class="upload-name">{upload.filename}</div>
  <div class="upload-subtitle">
    <span class="upload-candidate-name"
      >{upload?.candidates?.[0]?.name || STATUS_TO_TEXT[upload.status]}</span
    >
    {#if PROCESSED_STATUSES.includes(upload.status)}
      <div class="subtitle-divider"></div>
      <span>Created {formatDate(upload.updatedAt)}</span>
    {/if}
  </div>
</div>
